import React from 'react'

interface IVeeMarkProps {
  size?: number
  working?: boolean
}

// Paths verbatim from VT-Logo-Purple.svg; both subpaths in one path so the V stays a winding-rule cutout.
const V_BADGE_PATH = [
  'M20.2799,10.0324 C19.7619,10.1994 19.2449,10.3664 18.7039,10.5844 C12.2469,13.1934 6.9939,20.6724 8.9429,25.4954',
  'C9.9979,28.1064 11.8329,28.4194 14.5009,27.3414 C14.3299,27.0304 13.7099,26.9434 12.9629,25.0944',
  'C11.3519,21.1054 12.0649,17.5274 15.7809,14.5924 L25.7869,39.3574 L32.2569,36.9624 L32.0899,5.6064',
  'L28.7909,6.7204 L29.6379,32.1924 L20.2799,10.0324 Z',
  'M1.7449,26.8004 C-1.8501,18.4174 2.4989,8.8544 11.4469,5.4464 L20.7229,1.9144',
  'C29.6769,-1.4956 39.8519,2.5414 43.4449,10.9204 L47.1689,19.6054 C50.7639,27.9894 46.4139,37.5514 37.4659,40.9594',
  'L28.1899,44.4914 C19.2369,47.9014 9.0619,43.8644 5.4689,35.4864 L1.7449,26.8004 Z',
].join(' ')

const SPARKLE_PATH = 'M52,-9 L53.6,-4.1 L58.5,-2.5 L53.6,-0.9 L52,4 L50.4,-0.9 L45.5,-2.5 L50.4,-4.1 Z'

export const VeeMark: React.FC<IVeeMarkProps> = ({ size = 24, working = false }) => (
  <svg className={`vee-mark ${working ? 'vee-mark-working' : ''}`} width={size} height={size} viewBox="-4 -10 66 60" fill="currentColor" aria-hidden="true">
    <path d={V_BADGE_PATH} />
    <path d={SPARKLE_PATH} />
  </svg>
)
